import { createSlice } from "@reduxjs/toolkit";

const sandhayaSlice = createSlice({
  name: "sandhayaAdd",
  initialState: {
    isSandhayaAddOpen: false,
  },
  reducers: {
    toogleSandhayaAdd: (state) => {
      state.isSandhayaAddOpen = !state.isSandhayaAddOpen;
    },
  },
});

export const { toogleSandhayaAdd } = sandhayaSlice.actions;
export default sandhayaSlice.reducer;